export default "__VITE_ASSET__DT9tPdkW__"